import { format } from 'date-fns';

export function formatLastRefundTimeStamp(lastRefundTimestamp: number): string {
  return format(new Date(lastRefundTimestamp), 'MMM d, yyyy hh:mm a');
}
